
import { defineComponent } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import Swal from 'sweetalert2/dist/sweetalert2.min.js';
import { useRoute } from 'vue-router';
import * as Yup from 'yup';
import ApiService from '@/core/services/ApiService';
import { VueCookieNext } from 'vue-cookie-next';

export default defineComponent({
  name: 'institute-employee-add',
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  data() {
    return {
      url: '',
      employee_url: '',
      load: false,
      dialogVisible: false,
      alertText: false,
      employee: {
        tranche_id: '',
        entity_id: '',
        employee_father_name: '',
        employee_mother_name: '',
        employee_name: '',
        role: '',
        designation: '',
        employee_dob: '',
        employee_nid: '',
        employee_passport: '',
        employee_driving_license: '',
        employee_mobile: '',
        employee_email: '',
        employee_gender: '',
        employee_religion: '',
        employee_present_address: '',
        employee_present_district: '',
        employee_permanent_address: '',
        employee_permanent_district: '',
        employee_img: '',
      },
      user: {
        password: '',
        password_confirmation: '',
        active_status: '1',
      },
      contact_person: {
        image: '',
      },
      entityTypes: [],
      industry: [],
      entityInfos: [],
      divisions: [],
      districts: [],
      subDistricts: [],
      empDistricts: [],
      entity_type_id: '',
      tranche: [],
      institute: [],
      loading: false,
      empDesignation: [],
      instituteInfoId: '',
    };
  },
  async created() {
    await this.getTranche();
    await this.getDistrictForEmp();
    await this.getTrainningPartner();
    //await this.getEmployeeDesignation();
    this.instituteInfoId = this.instituteInfoId;
  },
  methods: {
    async getTranche() {
      await ApiService.get('configurations/tranche/list')
        .then((response) => {
          this.tranche = response.data.data;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    async getTrainningPartner() {
      await ApiService.get(
        'institute/detail/get_entity_institute_info/' +
          this.instituteInfoId +
          '?active_status=1&unique_entity=1'
      )
        .then((response) => {
          this.entityInfos = response.data.data;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    employeePhoto(e) {
      this.employee.employee_img = e.target.files[0];
      this.employee_url = URL.createObjectURL(this.employee.employee_img);
    },
    async getEmployeeDesignation() {
      await ApiService.get('entity_type_role/role/allroles?entity_type_id=1011&entity_id='+this.employee.entity_id)
        .then((response) => {
          this.empDesignation = response.data.data.role;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },

    async formSubmit() {
      let formData = new FormData();
      formData.set('employee_img', this.employee.employee_img);
      formData.set('institute_info_id', this.instituteInfoId);
      for (var key in this.employee) {
        formData.set(key, this.employee[key]);
      }
      for (var key in this.user) {
        formData.set(key, this.user[key]);
      }
      let user_id = VueCookieNext.getCookie('_seip_user');
      formData.set('user_id', user_id.id);
      this.loading = true;
      await ApiService.post('institute/save_institute_employee', formData)
        .then((response) => {
          this.loading = false;
          if (response.status == 200) {
            Swal.fire({
              title: 'Success!',
              text: response.data.data,
              icon: 'success',
              buttonsStyling: false,
              confirmButtonText: 'Ok',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
            }).then(() => {
              (this.url = ''), (this.employee_url = '');
              this.employee = {
                tranche_id: '',
                entity_id: '',
                employee_father_name: '',
                employee_mother_name: '',
                employee_name: '',
                role: '',
                designation: '',
                employee_dob: '',
                employee_nid: '',
                employee_passport: '',
                employee_driving_license: '',
                employee_mobile: '',
                employee_email: '',
                employee_gender: '',
                employee_religion: '',
                employee_present_address: '',
                employee_present_district: '',
                employee_permanent_address: '',
                employee_permanent_district: '',
                employee_img: '',
              };
              this.user = {
                password: '',
                password_confirmation: '',
                active_status: '1',
              };
            });
          } else {
            let err = '';
            for (const field of Object.keys(response.data.errors)) {
              err += response.data.errors[field][0] + '<br>';
            }
            Swal.fire({
              title: 'Please check all the required field',
              html: err,
              icon: 'error',
              buttonsStyling: false,
              confirmButtonText: 'Close',
              customClass: {
                confirmButton: 'btn btn-danger',
              },
            });
          }
        })
        .catch(({ response }) => {
          this.loading = false;
          Swal.fire({
            title: 'Unknown error',
            html: response.data.error,
            icon: 'error',
            buttonsStyling: false,
            confirmButtonText: 'Close',
            customClass: {
              confirmButton: 'btn btn-danger',
            },
          });
          console.log(response);
        });
    },

    async getDistrictForEmp() {
      await ApiService.get('configurations/geo_district/list')
        .then((response) => {
          this.empDistricts = response.data.data;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
  },
  setup() {
    const AssociationSchema = Yup.object().shape({
      // employeeEmail: Yup.string()
      //   .email("Must be valid email")
      //   .required()
      //   .label("Email"),
      //presentDistrict: Yup.string().required().label("Present District"),
      // name: Yup.string().required().label("Name"),
      // designation: Yup.string().required().label("Designation"),
      // gender: Yup.string().required().label("Gender"),
      // religion: Yup.string().required().label("Religion"),
      // father_name: Yup.string().required().label("Father name"),
      // mother_name: Yup.string().required().label("Mother name"),
      // mobile: Yup.number().required().min(11).label("Mobile"),
      // dob: Yup.string().required().label("Date of Birth"),
      // nid: Yup.string().required().label("NID"),
      // password: Yup.string()
      //   .required()
      //   .matches(
      //     /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])(?=.{8,})/,
      //     "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
      //   )
      //   .label("Password"),
      // confirmPassword: Yup.string()
      //   .oneOf([Yup.ref("password"), null], "Password didn't match!")
      //   .label("Confirm Password"),
    });
    const route = useRoute();
    const instituteInfoId = route.params.id;
    return {
      AssociationSchema,
      instituteInfoId,
    };
  },
});
